import { useLazyQuery } from "@apollo/client/react";

import { queryDocuments } from "@smart/manage-gql-operations-dom";

export const useLazyLoadRelationships = () => {
  const [load] = useLazyQuery(queryDocuments.relationships);

  return async (variables: { matterId: string; roleId: string }) => {
    const result = await load({ variables });
    return result.data?.relationships;
  };
};
